// extracted by mini-css-extract-plugin
export default {"week":"_calendar-item_week__Ps7TW","day":"_calendar-item_day__7+3iA","disabled":"_calendar-item_disabled__rhxPx"};